import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { UserState } from 'app/state-management/user-state';
import { AuthSession } from '@aws-amplify/auth';
import { CookbookState } from 'app/state-management/cookbook-state';
import { UserAuthService } from 'app/services/api-service/user-auth-service/user-auth-service';
import { NotificationService } from 'app/services/local-services/notification-service.service';
import { UserDataService } from 'app/services/api-service/user-data-service/user-data.service';
import { NgOptimizedImage } from '@angular/common';
import { TopBarHamburgerComponent } from './top-bar-hamburger/top-bar-hamburger.component';

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css'],
  imports: [RouterLink, NgOptimizedImage, TopBarHamburgerComponent],
})
export class TopBarComponent {
  loggedIn = false;
  logginButtonText = 'Log In';

  isMobile = false;
  hideButtons = false;
  hideHamburger = true;

  constructor(
    private authService: UserAuthService,
    private router: Router,
    private userState: UserState,
    private cookbookState: CookbookState,
    private notificationService: NotificationService,
    private userDataService: UserDataService,
  ) {
    router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event) => {
      this.updateLoggedInInfo();
    });
  }

  ngOnInit() {
    this.userState.loggedIn.subscribe((res) => {
      this.loggedIn = res;
      this.logginButtonText = this.loggedIn ? 'Logout' : 'Log In';
    });
    this.updateLoggedInInfo();
  }

  logout() {
    if (this.loggedIn) {
      this.authService
        .logout()
        .then((res) => {
          this.updateLoggedInInfo();
          this.userState.setIsLogin(false);
          this.router.navigate(['login']);
          this.notificationService.notify({
            message: 'You have been logged out',
            type: 'success',
          });
        })
        .catch((err) => {
          this.notificationService.notify({
            message: 'Error logging out. Please try again in a few moments',
            type: 'error',
          });
        });
    } else {
      const routerState = this.router.routerState;
      if (routerState.snapshot.url !== '/') {
        const redirectUrl = encodeURI(routerState.snapshot.url);
        this.router.navigateByUrl(
          this.router.createUrlTree(['/login'], {
            queryParams: { redirect: redirectUrl },
          }),
        );
      } else {
        this.router.navigateByUrl('/login');
      }
    }
  }

  updateLoggedInInfo() {
    this.authService.getSession().then((res: AuthSession) => {
      // console.log(res.tokens?.idToken?.toString());
      this.userState.setIsLogin(res.tokens ? true : false);
      this.userState.setGroups(
        (res.tokens?.accessToken?.payload['cognito:groups'] as string[]) ?? [],
      );
      this.userState.setUsername(res.tokens?.idToken?.payload['cognito:username'] as string);
    });
  }

  showManagements() {
    if (this.userState.isInGroup('admins') || this.userState.isInGroup('moderators')) {
      return true;
    }
    return false;
  }

  clearCaches() {
    this.cookbookState.clearCurrentPage();
    this.cookbookState.clearTab();
  }

  async createNew() {
    if (
      (await this.userDataService.getCurrentRecipeCount()) >= this.userDataService.getMaxRecipes()
    ) {
      this.notificationService.notify({
        type: 'warning',
        message: 'You have reached the current recipe limit of 100 recipes per account. Sorry',
      });
      return;
    }

    this.router.navigate(['/create-recipe']);
  }
}
